module.exports = __webpack_public_path__ + "img/iota.d2aa1c0a.png";